import { render, staticRenderFns } from "./TmHighlight.vue?vue&type=template&id=83732d0c"
import script from "./TmHighlight.vue?vue&type=script&lang=ts"
export * from "./TmHighlight.vue?vue&type=script&lang=ts"
import style0 from "./TmHighlight.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default})
